import { MobileApp } from 'modules/mobileApps/types';
import { CustomAppsList } from './CustomAppsList';
import { SelectiveTargetingOptionValues } from './SelectiveTargeting.constants';
import {
  RadioRow,
  StyledRadio,
  TargetingOptionLabel,
  AppsListSubtextContainer,
  CustomListContainer,
} from './SelectiveTargeting.styled';
import { SelectiveTargetingOption } from './SelectiveTargeting.types';
import { getTargetingOptionHelpTooltip, getAppsListSubtext } from './utils';

interface DropdownContentProps {
  selectedTargetingOption: SelectiveTargetingOption;
  onChangeSelectedTargetingOption: (option: SelectiveTargetingOption) => void;
  targetingOptions: SelectiveTargetingOption[];
  mobileApps: MobileApp[];
  mobileAppIds: number[];
  setMobileAppIds: (val: number[]) => void;
}

export const DropdownContent = ({
  selectedTargetingOption,
  onChangeSelectedTargetingOption,
  targetingOptions,
  mobileApps,
  mobileAppIds,
  setMobileAppIds,
}: DropdownContentProps) => {
  const { CUSTOM } = SelectiveTargetingOptionValues;

  return (
    <>
      {targetingOptions.map((option) => (
        <RadioRow key={option.id}>
          <StyledRadio
            id={`radio-${option.value}`}
            isChecked={selectedTargetingOption === option}
            onClick={() => onChangeSelectedTargetingOption(option)}
            value={option.value}
          />
          <div>
            <TargetingOptionLabel>
              {option.name}
              {option.tooltip && getTargetingOptionHelpTooltip(option.tooltip)}
            </TargetingOptionLabel>
            <AppsListSubtextContainer>
              {getAppsListSubtext(option, mobileApps)}
            </AppsListSubtextContainer>
          </div>
        </RadioRow>
      ))}
      {selectedTargetingOption.value === CUSTOM && (
        <CustomListContainer>
          <CustomAppsList
            mobileApps={mobileApps}
            mobileAppIds={mobileAppIds}
            setMobileAppIds={setMobileAppIds}
          />
        </CustomListContainer>
      )}
    </>
  );
};
